/**
 * Created by richard on 7/14/14.
 */
var notificationModel = angular.module('notificationModel', ['schoolModel']);
notificationModel.factory('NotificationModelFactory', function(BaseModel, RestService, authServiceFactory, $q) {
    var NotificationModel = function(){
        this.endpoint = "/notifications";
    }
    NotificationModel.prototype = new BaseModel();
    NotificationModel.prototype.parent = BaseModel.prototype;

    NotificationModel.prototype.resolveData = function (arg, headers)
    {
        var deferred = $q.defer();
        $q.all([
                RestService.get(this.getEndpoint(arg, headers), headers),
            ]).then( (results) => {
                this.arg = arg;
                this.set(results[0].data);
                deferred.resolve(results[0].data);
            }, (results) => {
                window.location.href = "/";
            });
        return deferred.promise;
    }

    return NotificationModel;
});

notificationModel.service('NotificationModelService', function(NotificationModelFactory){
    var notificationModel = new NotificationModelFactory();
    return notificationModel;
});
